export const LOGIN_CONNECTIONS = {
  EMAIL: "email",
  SMS: "sms",
  AUTHENTICATOR: "authenticator",
} as const;
export const RESEND_PASSWORDLESS_TIMEOUT = 60;

export const LINK_EXPIRED = "passwordless.link-expired";

export const LOGIN_FLOW = {
  REGISTER: "register",
  LOGIN: "login",
} as const;

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "danger",
  INFO: "info",
};
export const OPENLOGIN_DAPP_MODULE_KEY = "openlogin";
// this are just the normal W logo.
export const DEFAULT_LOGO_LIGHT = "https://images.web3auth.io/web3auth-logo-w-light.svg";
export const DEFAULT_LOGO_DARK = "https://images.web3auth.io/web3auth-logo-w.svg";

export const PASSWORDLESS_SERVER_API_URL = "https://api.web3auth.io/passwordless-service";
export const PASSWORDLESS_SERVER_SOCKET_URL = "https://api-passwordless.web3auth.io";
export const DEVELOP_PASSWORDLESS_SERVER_API_URL = "https://api-develop.web3auth.io/passwordless-service";
export const DEVELOP_PASSWORDLESS_SERVER_SOCKET_URL = "https://api-develop-passwordless.web3auth.io";
